// Nada notifikasi disintesis langsung via Web Audio API supaya tidak perlu asset audio
// tambahan; satu AudioContext dipakai ulang (browser membatasi jumlah context per halaman).
// Mirror persis dari livechat-customer-fe/src/pages/ChatScreen.jsx#playNotificationSound.
let notificationAudioCtx = null;

export function playNotificationSound(loud = false) {
    try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return;
        if (!notificationAudioCtx) notificationAudioCtx = new AudioContextClass();
        const ctx = notificationAudioCtx;
        if (ctx.state === "suspended") ctx.resume();

        const now = ctx.currentTime;
        const peakGain = loud ? 0.85 : 0.45;
        [880, 1175].forEach((freq, i) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = loud ? "triangle" : "sine";
            osc.frequency.value = freq;
            const start = now + i * 0.12;
            gain.gain.setValueAtTime(0, start);
            gain.gain.linearRampToValueAtTime(peakGain, start + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.25);
            osc.connect(gain).connect(ctx.destination);
            osc.start(start);
            osc.stop(start + 0.3);
        });
    } catch {
        // notifikasi suara bersifat best-effort — jangan sampai mengganggu alur chat
    }
}
